import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { svgs } from "../../../../../../core/constants/svgs";
import { PLACEHOLDER_IMAGE_URL } from "../../../../../../core/constants/constants";
import rephraseIcon from "../../../../../../assets/png/rephrase.png";

const ChapterUpload = ({
  item,
  index,
  uploadImagesArr,
  otherPhotoInputId,
  otherPhotoImageId,
  onUploadImageClick,
  onUploadImageChange,
  onRemoveImage,
  onGenerateChapterImageWithAI,
  generatingChapterId,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState(null);

  // Find the next available slot for upload
  const getNextAvailableSlot = () => {
    for (let i = 0; i < uploadImagesArr.length; i++) {
      const imageElement = document.getElementById(otherPhotoImageId(index, i));
      if (!imageElement || imageElement.src.includes("placehold.co")) {
        return i;
      }
    }
    return -1; // No slots available
  };

  const handleUploadClick = () => {
    const nextSlot = getNextAvailableSlot();
    if (nextSlot !== -1) {
      onUploadImageClick("chap_" + item?.id + "_media_" + nextSlot)();
    }
  };

  const handleFileChange = (e) => {
    const nextSlot = getNextAvailableSlot();
    if (nextSlot !== -1) {
      onUploadImageChange(index, nextSlot)(e);
    }
  };

  // Count uploaded images
  const getUploadedImagesCount = () => {
    let count = 0;
    for (let i = 0; i < uploadImagesArr.length; i++) {
      const imageElement = document.getElementById(otherPhotoImageId(index, i));
      if (imageElement && !imageElement.src.includes("placehold.co")) {
        count++;
      }
    }
    return count;
  };

  const uploadedCount = getUploadedImagesCount();
  const maxImages = uploadImagesArr.length;
  const isGeneratingThis = generatingChapterId === item?.id;
  const hasChapterTitle = item?.name && item.name.trim() !== "";

  const handleModalUploadClick = () => {
    setShowModal(false);
    handleUploadClick();
  };

  const handleModalAIGenerateClick = () => {
    setShowModal(false);
    onGenerateChapterImageWithAI(item, index);
  };

  return (
    <div className="upload-image">
      <div className="d-flex flex-column">
        {/* Single button to open modal */}
        <div className="mb-3 d-flex align-items-center flex-wrap">
          <input
            type="file"
            multiple={false}
            accept="image/jpeg, image/png, image/jpg"
            id={`upload-input-${item?.id}`}
            className="d-none"
            onChange={handleFileChange}
          />
          <button
            type="button"
            className="btn"
            disabled={uploadedCount >= maxImages || isGeneratingThis}
            onClick={() => uploadedCount < maxImages && !isGeneratingThis && setShowModal(true)}
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0.25rem 0.5rem",
              display: "flex",
              alignItems: "center",
              cursor: uploadedCount < maxImages && !isGeneratingThis ? "pointer" : "not-allowed",
              opacity: uploadedCount < maxImages && !isGeneratingThis ? 1 : 0.5,
              color: "#C47A26",
              fontSize: "14px",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginRight: "6px" }}
            >
              <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.64 16.2a2 2 0 0 1-2.83-2.83l8.49-8.49" />
            </svg>
            {t("attach_images")}
          </button>
        </div>

        {/* Display Uploaded Images */}
        <div className="d-flex flex-wrap">
          {uploadImagesArr.map((image_item, image_index) => (
            <div
              key={"uploaded-image-" + index + "-" + image_index}
              className="me-3 mb-3"
              style={{ position: "relative" }}
            >
              {/* Hidden input for each slot (keeping original structure) */}
              <input
                type="file"
                multiple={false}
                accept="image/jpeg, image/png, image/jpg"
                id={otherPhotoInputId(item?.id, image_index)}
                className="d-none"
                onChange={onUploadImageChange(index, image_index)}
              />

              {/* Image container - initially hidden */}
              <div
                id={"container-" + otherPhotoInputId(item?.id, image_index)}
                className="selected-img-container d-none"
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <div
                  className="img-delete-button"
                  onClick={onRemoveImage(
                    otherPhotoInputId(item?.id, image_index),
                    otherPhotoImageId(index, image_index),
                  )}
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    backgroundColor: "#ff0000",
                    color: "white",
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontSize: "18px",
                    fontWeight: "bold",
                    lineHeight: "1",
                    border: "2px solid white",
                    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 0, 0, 0.2)",
                    zIndex: 10,
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#cc0000";
                    e.currentTarget.style.transform = "scale(1.15)";
                    e.currentTarget.style.boxShadow = "0 4px 14px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(0, 0, 0, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#ff0000";
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 3px 10px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(0, 0, 0, 0.2)";
                  }}
                >
                  ×
                </div>
                <img
                  id={otherPhotoImageId(index, image_index)}
                  className="img-fluid"
                  style={{
                    border: "1px dotted black",
                    borderRadius: "0.5rem",
                    maxWidth: "150px",
                    maxHeight: "150px",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                  src={PLACEHOLDER_IMAGE_URL}
                  alt={`Uploaded image ${image_index + 1}`}
                  onClick={(e) => {
                    if (!e.target.src.includes("placehold.co")) {
                      setPreviewImageSrc(e.target.src);
                    }
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Preview Modal */}
      {previewImageSrc && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
          onClick={() => setPreviewImageSrc(null)}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "10px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setPreviewImageSrc(null)}
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                width: "36px",
                height: "36px",
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "50%",
                fontSize: "20px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
                zIndex: 1,
              }}
            >
              ×
            </button>
            <img
              src={previewImageSrc}
              alt="Chapter Image Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </div>
        </div>
      )}

      {/* Modal for choosing upload method */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "20px",
              width: "90%",
              maxWidth: "300px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h5 style={{ marginBottom: "20px", textAlign: "center" }}>
              {t("choose_cover_option")}
            </h5>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={handleModalUploadClick}
                style={{
                  flex: 1,
                  padding: "12px",
                  backgroundColor: "#e8935f",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                {t("upload_image")}
              </button>
              {hasChapterTitle && (
                <button
                  onClick={handleModalAIGenerateClick}
                  disabled={isGeneratingThis}
                  style={{
                    flex: 1,
                    padding: "12px",
                    backgroundColor: isGeneratingThis ? "#ccc" : "#6c63ff",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: isGeneratingThis ? "not-allowed" : "pointer",
                    fontWeight: "600",
                  }}
                >
                  {isGeneratingThis ? t("generating") : t("ai_generate")}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChapterUpload;
